export * from "./legacy";
export {
    clientsApi,
    useGetClientsQuery,
    useUpdateClientFieldMutation,
    useBindClientMutation,
    useGetClientTransitionsQuery,
    useGetUserFinanceGroupQuery,
} from "./rtk";
